module.exports = __webpack_public_path__ + "images/category_lp/earphone/store_images/2_bdc7725efb2ababdf8adae1b0dc52f7c.png";